import { render } from "./EvalComponentCard.vue?vue&type=template&id=0ae1d7a6"
import script from "./EvalComponentCard.vue?vue&type=script&lang=js"
export * from "./EvalComponentCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__